































import { Component, Vue, Watch } from "vue-property-decorator";
import Permissions from "./Permissions.vue"
import MatrixVisibillity from "./MatrixVisibillity.vue"
import SalesAgents from "./SalesAgents.vue"

@Component({
  components: {
    Permissions,
    MatrixVisibillity,
    SalesAgents
  }
})
export default class ManageUsers extends Vue {


}
